const RxrdCustomJobNbrHeader = (props: any) => {
    return (
        <div style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            height: "100%",
            width: "84%"
        }}
        >
            <div >
                Job#
            </div>
            <div
                style={{
                    fontSize: "10px",
                    lineHeight: "1.2",
                    textTransform: "none",
                    fontWeight: 400,
                    position: "absolute",
                    top: "60%",
                    left: "50%",
                    transform: "translateX(-50%)",
                    paddingTop: "2px"
                }}
            >
                (Click blue text for detail)
            </div>
        </div>
    );
};

export default RxrdCustomJobNbrHeader;